import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _propTypes;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  stroke: black;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  visibility: visible !important;\n  opacity: 0 !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 100%;\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cuid from 'cuid';
import { BodyConfig, TitleConfig, MicroConfig, TypographyConfig } from '@vds-core/typography';
import { RadioBoxLabelWrapper, RadioBoxLabel, SubLabel, StackedLabel } from './RadioBoxElements';
import { colors } from '@vds-core/theme';
import { withVDSManager } from '@vds-core/utilities';
var coreTypescale = TypographyConfig.getTypescale();

function _calcTypography(typescale, stacked, component) {
  if (stacked && component === 'text') {
    return TitleConfig.getStyles(typescale, 'mobile', 'small');
  } else if (component === 'text') {
    return BodyConfig.getStyles(typescale, 'desktop', 'small');
  } else {
    return MicroConfig.getStyles(typescale, 'desktop');
  }
}

var propTypes = (_propTypes = {
  /**
   * If provided, the RadioBox will be rendered with children.
   */
  children: PropTypes.node,

  /**
   * If provided, the RadioBox will be rendered in the Disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * If provided, will set a custom width for the radiobox label wrapper.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Name of RadioBox.
   */
  name: PropTypes.string.isRequired,

  /**
   * Callback function that returns the value of the RadioBox when clicked.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * If provided, the RadioBox will be rendered in the Selected State.
   */
  selected: PropTypes.bool,

  /**
   * If provided, the RadioBox text will be rendered.
   */
  text: PropTypes.string.isRequired,

  /**
   * If provided, the RadioBox subtext will be rendered.
   */
  subtext: PropTypes.string,

  /**
   * @deprecated
   * If provided, the RadioBox will be rendered in the Stacked State.
   */
  stacked: PropTypes.bool,

  /**
   * Value of RadioBox.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * If provided, the uniqueId of the RadioBox will be rendered.
   */
  uniqueId: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * @ignore
   * Set a different min-height on the box
   */
  minHeight: PropTypes.string,

  /**
   * @ignore
   * Set a different padding inside the box
   */
  padding: PropTypes.string,

  /**
   * @ignore
   * Font styles for the typography
   */
  labelMargin: PropTypes.bool,

  /**
   * @ignore
   * Orientation of the radiobox from the group (controls indicator position)
   */
  orientation: PropTypes.string,

  /**
   * @ignore
   * If provided, the radio box will be rendered to show that the option is out of stock.
   */
  outOfStock: PropTypes.bool,

  /**
   * @ignore
   * If provided, the radio box will use the updated disabled state without strikethrough
   */
  disabledState: PropTypes.bool,

  /**
   * @ignore
   * If provided, the radio box will apply hover state
   */
  hoverState: PropTypes.bool,

  /**
   * @ignore
   * If provided, the radio box will apply active state
   */
  activeState: PropTypes.bool,

  /**
   * @ignore
   * If provided, the radio box will apply updated focus state
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   * Typescale for the Typography
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * Return the proper typography config based on type of sub-component and typescale
   */
  calcTypography: PropTypes.func
}, _defineProperty(_propTypes, "typescale", PropTypes.string), _defineProperty(_propTypes, "borderColor", PropTypes.string), _defineProperty(_propTypes, "backgroundColor", PropTypes.string), _defineProperty(_propTypes, "colorConfig", PropTypes.object), _defineProperty(_propTypes, 'data-track', PropTypes.string), _defineProperty(_propTypes, 'data-analyticstrack', PropTypes.string), _defineProperty(_propTypes, 'data-clickstream', PropTypes.string), _defineProperty(_propTypes, "inputId", PropTypes.string), _propTypes);
var defaultProps = {
  children: null,
  disabled: false,
  name: '',
  onChange: function onChange() {},
  selected: false,
  uniqueId: '',
  stacked: false,
  subtext: '',
  text: '',
  width: '100%',
  //Deprecated
  //id: ''
  //1.0
  labelMargin: true,
  outOfStock: false,
  disabledState: false,
  hoverState: false,
  activeState: false,
  focusState: false,
  typescale: coreTypescale,
  calcTypography: _calcTypography,
  borderColor: colors.coolGray3,
  backgroundColor: 'transparent',
  colorConfig: colors
};
var StyledDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledDiv",
  componentId: "sc-7uwm3-0"
})(_templateObject());
var StyledInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "StyledInput",
  componentId: "sc-7uwm3-1"
})(_templateObject2());
var ChildWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ChildWrapper",
  componentId: "sc-7uwm3-2"
})(_templateObject3());
var StrikethroughWrapper = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StrikethroughWrapper",
  componentId: "sc-7uwm3-3"
})(_templateObject4());
var Line = /*#__PURE__*/styled.line.withConfig({
  displayName: "Line",
  componentId: "sc-7uwm3-4"
})(_templateObject5());

var RadioBox = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioBox, _React$Component);

  var _super = _createSuper(RadioBox);

  function RadioBox() {
    var _this;

    _classCallCheck(this, RadioBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: false,
      forceFocus: false,
      active: false,
      hovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "_forceFocus", function () {
      _this.setState({
        forceFocus: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_hovered", function () {
      _this.setState(function (prevState) {
        return {
          hovered: !prevState.hovered
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_removeForceFocus", function () {
      _this.setState({
        forceFocus: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_focused", function () {
      _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_unfocused", function () {
      _this.setState({
        focused: false,
        clicked: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e) {
      _this.props.onChange(e);

      if (e.type === 'click') {
        _this.setState({
          clicked: !_this.state.clicked
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", function (e) {
      //keeps IE happy
      _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", function (e) {
      _this.setState({
        active: false
      });
    });

    return _this;
  }

  _createClass(RadioBox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          name = _this$props.name,
          onChange = _this$props.onChange,
          selectedProp = _this$props.selected,
          subtext = _this$props.subtext,
          id = _this$props.id,
          className = _this$props.className,
          stacked = _this$props.stacked,
          text = _this$props.text,
          uniqueId = _this$props.uniqueId,
          value = _this$props.value,
          width = _this$props.width,
          minHeight = _this$props.minHeight,
          padding = _this$props.padding,
          labelMargin = _this$props.labelMargin,
          orientation = _this$props.orientation,
          outOfStock = _this$props.outOfStock,
          disabledState = _this$props.disabledState,
          hoverState = _this$props.hoverState,
          focusState = _this$props.focusState,
          activeState = _this$props.activeState,
          typescale = _this$props.typescale,
          calcTypography = _this$props.calcTypography,
          borderColor = _this$props.borderColor,
          backgroundColor = _this$props.backgroundColor,
          colorConfig = _this$props.colorConfig,
          height = _this$props.height,
          inputId = _this$props.inputId,
          track = _this$props['data-track'],
          analyticsTrack = _this$props['data-analyticstrack'],
          clickStream = _this$props['data-clickstream'];
      var radioId = inputId ? inputId : cuid();
      var Label = subtext ? StackedLabel : RadioBoxLabel,
          unique_id = id || uniqueId,
          selected = selectedProp,
          val = value || id || uniqueId;
      var textConfig = calcTypography(typescale, subtext, 'text');
      var subtextConfig = subtext ? calcTypography(typescale, subtext, 'subtext') : '';
      return /*#__PURE__*/React.createElement(RadioBoxLabelWrapper, {
        active: this.state.active,
        focused: this.state.focused,
        clicked: this.state.clicked,
        checked: selected,
        disabled: disabled,
        stacked: stacked,
        width: width,
        minHeight: minHeight,
        orientation: orientation,
        outOfStock: outOfStock,
        disabledState: disabledState,
        hoverState: hoverState,
        activeState: activeState,
        focusState: focusState,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
        onMouseEnter: this._removeForceFocus,
        forceFocus: this.state.forceFocus,
        height: height,
        colorConfig: colorConfig,
        hovered: this.state.hovered,
        className: className,
        id: id
      }, outOfStock && /*#__PURE__*/React.createElement(StrikethroughWrapper, null, /*#__PURE__*/React.createElement(Line, {
        x1: "0",
        y1: "100%",
        x2: "100%",
        y2: "0"
      })), /*#__PURE__*/React.createElement(StyledDiv, {
        onMouseDown: this._onMouseDown,
        onMouseUp: this._onMouseUp,
        onMouseEnter: this._hovered,
        onMouseLeave: this._hovered
      }, /*#__PURE__*/React.createElement(Label, {
        outOfStock: outOfStock,
        padding: padding,
        disabled: disabled,
        disabledState: disabledState,
        htmlFor: radioId,
        textConfig: textConfig,
        labelMargin: labelMargin
      }, /*#__PURE__*/React.createElement(StyledInput, {
        "aria-checked": selected,
        type: "radio",
        checked: !disabled && selected,
        disabled: disabled,
        id: radioId,
        value: val,
        name: name,
        onClick: this._onClick,
        onChange: onChange,
        tabIndex: disabled ? -1 : 0,
        onFocus: this._focused,
        onBlur: this._unfocused,
        onKeyDown: this._forceFocus,
        "data-track": track,
        "data-analyticstrack": analyticsTrack,
        "data-clickstream": clickStream
      }), /*#__PURE__*/React.createElement(ChildWrapper, null, text && !children && /*#__PURE__*/React.createElement(ChildWrapper, {
        className: "LabelContent"
      }, text), subtext && !children && /*#__PURE__*/React.createElement(SubLabel, {
        subtextConfig: subtextConfig,
        className: "SubLabel"
      }, subtext), children && children))));
    }
  }]);

  return RadioBox;
}(React.Component);

RadioBox.propTypes = propTypes;
RadioBox.defaultProps = defaultProps;
export default withVDSManager(RadioBox);